import * as React from "react"
import type { SVGProps } from "react"
const SvgEmailDocument = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M14 9q.42 0 .71.29.3.29.29.71 0 .42-.29.71-.29.3-.71.29h-4a1 1 0 0 1-.71-.29A1 1 0 0 1 9 10q0-.42.29-.71.29-.3.71-.29zm1-3q.42 0 .71.29.3.29.29.71 0 .42-.29.71-.29.3-.71.29H9a1 1 0 0 1-.71-.29A1 1 0 0 1 8 7q0-.42.29-.71.29-.3.71-.29z" />
    <path
      fillRule="evenodd"
      d="M18 2q.83 0 1.41.59.6.59.59 1.41v3.12l1.05.63q.45.27.7.75t.25 1V20q0 .83-.59 1.41-.58.6-1.41.59H4q-.82 0-1.41-.59-.6-.59-.59-1.41V9.5q0-.52.25-1t.7-.75L4 7.12V4q0-.82.59-1.41Q5.18 1.99 6 2zm-4.97 13.72a2 2 0 0 1-2.06 0L4 11.55V20h16v-8.45zM6 4v6.42L12 14l6-3.58V4z"
    />
  </svg>
)
export default SvgEmailDocument
